import {Component} from '@angular/core';

@Component({
    selector: 'acabim-user-privacy',
    templateUrl: './privacy.component.html',
    styleUrls: ['./privacy.component.scss']
})
export class PrivacyComponent {

    protected name = 'PrivacyComponent';

    constructor() {}

}
